exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3xB91{position:relative;margin-bottom:0;background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3xB91>div>div{padding-top:10px;margin-bottom:20px}._24euK{padding:17px 0 0}._20ssr{margin:0 auto}._19ZBR{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._3YKrm{position:relative}.arY_m{width:calc(100% - 300px);padding-right:20px}._3Nic2{margin-bottom:15px}", ""]);

// exports
exports.locals = {
	"advertContainer": "_3xB91",
	"page": "_24euK page",
	"container": "_20ssr container",
	"flexRow": "_2JZ4K flexRow",
	"searchContainer": "_19ZBR",
	"flexCell": "_3YKrm",
	"mainCell": "arY_m",
	"advertContainerGl": "_3Nic2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/search/Search.css
// module id = 2879
// module chunks = 20